import _ from 'lodash';
import React, {useState, useEffect, useContext} from "react";
import Util from "../../util";
import Data from "../../data";
// components & contexts
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { AsyncImage, Link, LinkButton } from "../controls";
import { CatalogueContext } from "../../context";
// styling and icons
import "./ActivityPackageLink.scss";
import {faCartPlus} from "@fortawesome/free-solid-svg-icons";

export default function ActivityPackageLink({activityPackage}) {
  // context
  const CC = useContext(CatalogueContext);
  // state
  const [activities, setActivities] = useState([]);
  const [regions, setRegions] = useState([]); 
  const [minPrice, setMinPrice] = useState(0);

  // mount
  useEffect(() => {
    // acitivities
    const activities = activityPackage.activities
    .map(a => {
      return CC.activities.all.find(ca => ca._id === a.activityId) || null;
    })
    .filter(ca => ca !== null)
    .sort((a,b) => a.title.localeCompare(b.title))

    // regions
    const regions = activityPackage.regionVariants.map(rv => {
      return CC.regions.find(r => r.code === rv.regionCode) || null;
    })
    .filter(r => r !== null)
    .map(r => {
      return {
        code: r.code,
        title: Data.Regions.getTitle(r.code, "de").replace("Region", "").trim()
      }
      
    })
    .sort((a,b) => a.title.localeCompare(b.title))
    
    // find lowest price
    const allPriceConfigurations = [];
    activityPackage.regionVariants.forEach(rv => {
      rv.priceConfigurations.forEach(pc => {
        if(pc.price !== 0 && pc.participantCount !== 0) {
          allPriceConfigurations.push(pc);
        }
      })
    })
    const cheapestPriceConfiguration = _.minBy(allPriceConfigurations, pc => pc.price);
    setMinPrice(cheapestPriceConfiguration.price);

    // set state 
    setActivities(activities);
    setRegions(regions);

  }, [activityPackage, CC.activities.all, CC.regions]);
  

  // pre-render
  const img = <AsyncImage src={activityPackage.image.url} alt={activityPackage.title} />;
  const includedActivities = activities.map(a => <li key={a._id}>{a.title}</li>);
  //const availableRegions = regions.map(r => <div key={r.code}>{r.title}</div>);
  const availableRegions = regions.map(r => r.title).join(", ");

  // render
  return (
    <div className="c-activitypackage-link">
      
      <div className="inner boxshadow">

        <div className="top">

          <div className="image">
            <Link to={`/packages/${activityPackage.slug}`}>
              {img}
            </Link>
          </div>

          <div className="texts">
            <LinkedTitle activityPackage={activityPackage} />
            <div className="description">{activityPackage.shortDescription}</div>
            <div className="activities">
              <div className="title">Enthaltene Erlebnisse:</div>
              <ul>
                {includedActivities}
              </ul>
            </div>
            
            <div className="regions">verfügbar in: {availableRegions}</div>
          </div>
        </div>

        <div className="bottom">
          <div className="price">
            pro Person ab <span className="amount">{Util.Format.currency(minPrice.toFixed(2), true)}</span>
          </div>
          <Link to={`/packages/${activityPackage.slug}`}>
            <div className="cart"><FontAwesomeIcon icon={faCartPlus} /></div>
          </Link>  
        </div>

      </div>

    </div>
  )
}



function LinkedTitle({activityPackage}) {
  return (
    <Link to={`/packages/${activityPackage.slug}`}>
      <div className="title">
        {activityPackage.title}
      </div>
    </Link>
  )
}
